'use strict';

var BaseView = require('./base');

class MatrixFlipRowView extends BaseView {
    constructor(matrix) {
        super(matrix, matrix.rows, matrix.columns);
    }

    set(rowIndex, columnIndex, value) {
        this.matrix.set(this.rows - rowIndex - 1, columnIndex, value);
        return this;
    }

    get(rowIndex, columnIndex) {
        return this.matrix.get(this.rows - rowIndex - 1, columnIndex);
    }
}

module.exports = MatrixFlipRowView;



//////////////////
// WEBPACK FOOTER
// ./~/ml-pca/~/ml-matrix/src/views/flipRow.js
// module id = 281
// module chunks = 0